module.exports = __webpack_public_path__ + "img/logo-full_lugano.27ecb2de.png";